var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ol",
    { staticClass: "list-view" },
    _vm._l(_vm.items, function (item) {
      return _c(
        "li",
        {
          key: item.unique,
          staticClass: "list-view-item",
          class: { disabled: !item.isPurchasable && !_vm.isReferentieView },
        },
        [
          _c(
            "button",
            {
              staticClass: "list-view-item__button",
              attrs: { type: "button", title: item.description },
              on: {
                click: function ($event) {
                  return _vm.select(item)
                },
              },
            },
            [
              _c("div", { staticClass: "list-view-item__header" }, [
                _c("h3", { staticClass: "list-view-item__title" }, [
                  _vm._v(_vm._s(item.description)),
                ]),
                _vm._v(" "),
                item.pricing.discountLabelForDisplay(true)
                  ? _c("span", { staticClass: "list-view-item__discount" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(item.pricing.discountLabelForDisplay(true)) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              item.secondLine
                ? _c("span", { staticClass: "list-view-item__second-line" }, [
                    _vm._v("\n        " + _vm._s(item.secondLine) + "\n      "),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "list-view-item__pricing" },
                [
                  item.stats.sales
                    ? _c("span", { staticClass: "list-view-item__sold" }, [
                        _vm._v(_vm._s(item.stats.sales)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("Pricing", {
                    attrs: {
                      pricing: item.pricing,
                      type: "simple",
                      "show-promo-code": true,
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }